export default {
      Users: 'المستخدم|المستخدمين',

};
